
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('span', { 'className': 'custom-garage-icon' }, _createElement('svg', {
        'width': '14',
        'height': '14',
        'viewBox': '0 0 14 14',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'd': 'M0 3L7 0L14 3V14H12V6H2V14H0V3Z',
        'fill': '#2F2F2B'
    }), _createElement('rect', {
        'x': '3',
        'y': '7',
        'width': '8',
        'height': '1',
        'fill': '#2F2F2B'
    }), _createElement('rect', {
        'x': '3',
        'y': '9',
        'width': '8',
        'height': '1',
        'fill': '#2F2F2B'
    }), _createElement('rect', {
        'x': '3',
        'y': '11',
        'width': '8',
        'height': '1',
        'fill': '#2F2F2B'
    }))), _createElement('span', { 'className': 'garage-label' }, _translate(`garage_title`)), _createElement('span', { 'className': 'garage-size-desktop' }, ' (', this.size, ')')), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1930'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [_createElement('div', {}, _createElement('span', {}, _createElement('svg', {
                            'width': '16',
                            'height': '16',
                            'viewBox': '0 0 16 16',
                            'fill': 'none',
                            'xmlns': 'http://www.w3.org/2000/svg'
                        }, _createElement('circle', {
                            'cx': '8',
                            'cy': '8',
                            'r': '8',
                            'fill': '#2F2F2B'
                        }), _createElement('path', {
                            'd': 'M11.5 8L4.5 8',
                            'stroke': '#EDC70B',
                            'stroke-width': '1',
                            'stroke-linecap': 'round'
                        }), _createElement('path', {
                            'd': 'M8 11.5L8 4.5',
                            'stroke': '#EDC70B',
                            'stroke-width': '1',
                            'stroke-linecap': 'round'
                        }))), ' Add Vehicle')]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '2248'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  cm_button cm_button__primary cm_addButton' }, [_createElement('div', {}, _createElement('span', {}, _createElement('svg', {
                            'width': '16',
                            'height': '16',
                            'viewBox': '0 0 16 16',
                            'fill': 'none',
                            'xmlns': 'http://www.w3.org/2000/svg'
                        }, _createElement('circle', {
                            'cx': '8',
                            'cy': '8',
                            'r': '8',
                            'fill': '#2F2F2B'
                        }), _createElement('path', {
                            'd': 'M11.5 8L4.5 8',
                            'stroke': '#EDC70B',
                            'stroke-width': '1',
                            'stroke-linecap': 'round'
                        }), _createElement('path', {
                            'd': 'M8 11.5L8 4.5',
                            'stroke': '#EDC70B',
                            'stroke-width': '1',
                            'stroke-linecap': 'round'
                        }))), ' Add Vehicle')]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]